import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DictionaryRoutingModule } from './dictionary-routing.module';
import { DictionaryComponent } from 'src/app/pages/dictionary/dictionary.component';
import { DictionaryDropdownComponent } from 'src/app/shared/dictionary-dropdown/dictionary-dropdown.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { HtmlFormatPipeModule } from 'src/app/pipes/html-format-pipe.module';
import { AngularSvgIconModule } from 'angular-svg-icon';


@NgModule({
  declarations: [
    DictionaryComponent,
    DictionaryDropdownComponent,
  ],
  imports: [
    CommonModule,
    DictionaryRoutingModule,
    TranslateModule,
    HtmlFormatPipeModule,
    AngularSvgIconModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    DictionaryComponent,
  ]
})
export class DictionaryModule { }
